import { QuestionCircleOutlined } from '@ant-design/icons';
import { Modal, type ModalFuncProps } from 'antd';

type P = ModalFuncProps;

const modalWarning = (options: P) => Modal.warning({ icon: <QuestionCircleOutlined />, ...options });

export default modalWarning;
